import * as Sentry from "@sentry/react";

let initialized = false;

/**
 * Initialize Sentry. Call this from each entry's bootstrap BEFORE React mounts —
 * Sentry needs to be initialized before render so it can catch errors thrown
 * during the initial render pass.
 *
 * Silent (no-op) when VITE_SENTRY_DSN is unset, which is normal in local dev.
 *
 * sendDefaultPii is intentionally false — this is an enterprise customer-data
 * tool, so we don't auto-collect IPs/headers. Add context selectively via
 * Sentry.setUser / setContext / extra-on-captureException if needed.
 */
export function initSentry() {
  if (initialized) return;
  if (typeof window === "undefined") return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.DEV ? "development" : "production",
    release: import.meta.env.VITE_VERSION ?? "0.1.0",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });

  initialized = true;
}
